"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Center = void 0;
var React = require("react");
var styled_components_1 = require("styled-components");
var Center = function (_a) {
    var children = _a.children;
    return (React.createElement(Wrapper, { role: "presentation" }, children));
};
exports.Center = Center;
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: grid;\n    height: 100%;\n    width: 100%;\n    box-sizing: border-box;\n    justify-items: center;\n    align-items: center;\n"], ["\n    display: grid;\n    height: 100%;\n    width: 100%;\n    box-sizing: border-box;\n    justify-items: center;\n    align-items: center;\n"])));
var templateObject_1;
